import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App'; // Zorg ervoor dat de default export correct wordt geïmporteerd
import { ThemeProvider } from '@material-tailwind/react';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
